import type { ReactNode } from 'react';
import { tonePalette, type Tone } from './palette';

export function Pill({
  tone = 'good',
  icon,
  children,
}: {
  tone?: Tone;
  icon?: ReactNode;
  children: ReactNode;
}) {
  const t = tonePalette[tone];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold tracking-[0.06em]"
      style={{ background: t.bg, color: t.fg }}
    >
      {icon}
      {children}
    </span>
  );
}
